import classNames from 'classnames';
import React from 'react';
import Icon from 'components/Icon';
import { IconType } from 'components/Icon/constants';
import Dropdown from 'components/Toolbar/Shared/Dropdown';
import * as Constants from 'const';
import { intlGet } from 'utils/intlGet';
import styles from './styles.module.scss';

const TEXT_LINE_HEIGHTS = [
  {
    type: Constants.TextLineHeightValue.ONE,
    icon: IconType.LINE_HEIGHT_ONE,
    hint: intlGet('TextLineHeight.Hint', '1'),
  },
  {
    type: Constants.TextLineHeightValue.ONE_POINT_TWO,
    icon: IconType.LINE_HEIGHT_ONE_POINT_TWO,
    hint: intlGet('TextLineHeight.Hint', '1.2'),
  },
  {
    type: Constants.TextLineHeightValue.ONE_POINT_FIVE,
    icon: IconType.LINE_HEIGHT_ONE_POINT_FIVE,
    hint: intlGet('TextLineHeight.Hint', '1.5'),
  },
  {
    type: Constants.TextLineHeightValue.TWO,
    icon: IconType.LINE_HEIGHT_TWO,
    hint: intlGet('TextLineHeight.Hint', '2'),
  },
];

type Props = {
  blockLineHeight: Constants.TextLineHeightValue | undefined;
  setLineHeight: (type: Constants.TextLineHeightValue) => void;
  dataTestId?: string;
};

const TextLineHeight: React.FunctionComponent<Props> = (props) => {
  const { setLineHeight, blockLineHeight, dataTestId = 'textLineHeight' } = props;

  return (
    <Dropdown className={styles.TextLineHeight} dataTestId={`${dataTestId}-dropdown`}>
      {TEXT_LINE_HEIGHTS.map(
        ({ icon, hint, type }, index) => (
          <button className={classNames(styles.item, 'reset-button')}
            key={type} onClick={setLineHeight.bind(null, type)} data-testid={`${dataTestId}-item${index}`}>
            <Icon type={icon} size="md" color={type === blockLineHeight ? 'primary' : 'secondary'} />
            <span className={styles.hint} data-testid={`${dataTestId}-hint${index}`}>{hint}</span>
          </button>
        ),
      )}
    </Dropdown>
  );
};

export default TextLineHeight;
